module.exports = __webpack_public_path__ + "static/open-source-09ba2ab224ad20671a5608abbf313c26.png";